// @ts-check
import React from 'react';
import ReactModal from 'react-modal';

/** @typedef {
  | "xs"
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl"
  | "6xl"
  | "full"
} DrawerWidth */

/* eslint-disable quote-props */
/** @type { Record<DrawerWidth, string> } */
const widthClassNames = {
  xs: 'max-w-xs',
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  full: 'max-w-full',
};
/* eslint-enable quote-props */

/** @typedef {{
  isOpen: boolean;
  onRequestClose(): void;
  width: DrawerWidth;
  className?: string;
  overlayClassName?: string;
  closeTimeoutMS?: number;
}} DrawerProps */

/** @type { React.FC<DrawerProps> } */
export const Drawer = (props) => {
  const {
    isOpen,
    onRequestClose,
    width = 'sm',
    overlayClassName = '',
    className,
    children,
  } = props;

  const cn = [
    className,
    'z-10 fixed inset-y-0 right-0 m-0 w-full shadow-lg transform transition duration-500 sm:duration-700 ease-in-out overflow-y-auto translate-x-full',
    widthClassNames[width],
    !(className && className.includes('bg-')) ? 'bg-white' : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={{
        base: cn,
        afterOpen: isOpen ? 'seriously-translate-x-0' : '',
        beforeClose: 'translate-x-full',
      }}
      overlayClassName={`Overlay ${overlayClassName}`}
      closeTimeoutMS={300}
    >
      <div className="relative z-10">
        <div>{children}</div>
      </div>
    </ReactModal>
  );
};
